import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { Clock, LogOut, Mail } from "lucide-react";

export default function AguardandoAprovacaoPage() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-warm-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-warm-200 bg-white p-8 text-center shadow-sm">
        {/* Ícone */}
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-amber-50">
          <Clock size={32} className="text-amber-500" />
        </div>

        <h1 className="mb-2 text-2xl font-bold text-warm-900">
          Cadastro em análise
        </h1>
        <p className="mb-6 text-sm leading-relaxed text-warm-600">
          Recebemos seu cadastro! Nossa equipe irá analisá-lo em breve.
          Assim que sua conta for aprovada, você receberá acesso completo à
          plataforma.
        </p>

        <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-700">
          <div className="mb-1 flex items-center gap-1.5 font-semibold">
            <Mail size={14} />
            Fique atento ao seu e-mail
          </div>
          Você receberá uma notificação quando sua conta for aprovada.
        </div>

        <button
          onClick={handleLogout}
          className="flex w-full items-center justify-center gap-2 rounded-xl border border-warm-200 bg-warm-100 px-4 py-3 text-sm font-medium text-warm-700 transition-colors hover:bg-warm-200"
        >
          <LogOut size={16} />
          Sair da conta
        </button>
      </div>
    </div>
  );
}
